import { Injectable } from '@angular/core'
import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { CmsComponent } from '@spartacus/core'
import { TrainingHeaderComponentData } from './index'

@Injectable({ providedIn: 'root' })
export class TrainingHeaderConverter extends CmsConverterService<TrainingHeaderComponentData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      trainingId: formData.st_training_id?.value,
    }
  }
}
